<button
  class="opener"
  [class]="buttonClass"
  [disabled]="disabled"
  (click)="Open()"
>
  <div
    class="button-description"
    [ngClass]="{ 'trip-summary-context': tripSummaryContext }"
  >
    <fa-icon
      class="fa-2x"
      [icon]="buttonIcon"
      *ngIf="!buttonCustomIcon"
    ></fa-icon>
    <ciao-check-out-icon *ngIf="buttonCustomIcon === 'check-out'" />
    <ciao-check-in-icon *ngIf="buttonCustomIcon === 'check-in'" />

    <div class="button-text">
      <h4>{{ buttonText }}</h4>
      <br />
      <h5 class="button-message">{{ description }}</h5>
    </div>
  </div>
</button>

<ciao-modal
  #okayModal
  [title]="title"
  (modalInstance)="reinitializeValues()"
  [loading]="sendingRequest"
>
  <div class="modal-body" modalBody>
    <p *ngIf="canSendOkayAtAll$ | async" class="font-red">
      Note: You need to be on a Team to {{ displayValues.noTeamMessagePart }}.
      <a [routerLink]="'/help/info/how-to'">Learn how to join a Team here.</a>
    </p>
    <ng-container *ngIf="allowTripSelection">
      <ciao-form-field
        class="imSpecial"
        label="Choose Trip"
        type="combobox"
        [selectOptions$]="trips$"
        [formControlInput]="tripControl"
      ></ciao-form-field>
    </ng-container>
    <div *ngIf="myFormGroup.value.trip; let trip">
      <div class="trip-location">
        <mat-label>Location</mat-label>
        <p class="location-description">{{ getTripLocation(trip) }}</p>
        <p *ngIf="trip.locations?.length === 0 && okayType === 'checkOut'" class="font-red">
          This trip has no location set. Please add a location to the trip before checking out.
        </p>
      </div>
      <div class="trip-start">
        <mat-label>Start Date & Time</mat-label>
        <p class="start-datetime">{{ getTripStartTime(trip) }}</p>
      </div>
    </div>
    <ciao-form-field
      [label]="readableOkayType + ' Date'"
      type="datetime"
      [formControlInput]="timeOkayControl"
    ></ciao-form-field>
    <ciao-form-field
      [label]="'Notes'"
      [formControlInput]="notesControl"
    ></ciao-form-field>
    <ng-container *ngIf="crewMembers$ | async as crewMembersOptions">
      <ng-container
        *ngIf="okayType == 'checkIn' && crewMembersOptions.length > 1"
      >
        <ciao-form-checkbox-group
          [label]="'Crew Members'"
          [options]="crewMembersOptions"
          [selectAllEnabled]="true"
          [formControl]="crewMembersControl"
        ></ciao-form-checkbox-group>
        <span class="custom-checkbox-error">
          {{ myFormGroup.get("crewMembers")?.errors?.noneSelected ?? "" }}
        </span>
      </ng-container>
    </ng-container>
  </div>
  <p modalFooter>
    <button
      class="btn-action-solid confirm-button center"
      (click)="SendOkay()"
      [disabled]="myFormGroup.invalid || sendingRequest || (okayType === 'checkOut' && myFormGroup.value.trip?.locations?.length === 0)"
    >
      <fa-icon [icon]="buttonIcon"></fa-icon>
      {{ title }}
      <span class="confirm-button-desc">{{ description }}</span>
    </button>
  </p>
</ciao-modal>

<ciao-scheduled-checkpoint-modal
  #scheduledAlertsModal
  [requiresTripSelection]="true"
></ciao-scheduled-checkpoint-modal>
